import { Chip } from '@mui/material';

interface AddedItemsProps {
    addedItems: string[];
    isDeletable?: (value: string) => boolean;
    handleDelete?: (value: string) => void;
}

function AddedItems({addedItems, handleDelete, isDeletable}: AddedItemsProps) {
  return (
    <div className="added-items">
      {addedItems?.map(item => (
        <Chip 
          key={item} 
          label={item} 
          variant="outlined"
          onDelete={isDeletable?.(item) ? () => handleDelete?.(item) : undefined}/>
      ))}
    </div>
  );
}

export default AddedItems;